/* ============================================================
   Real OFW pricing, fetched once (data/prices.json - a snapshot
   pulled live from the OFW Shopify Admin API, keyed by numeric
   variant ID) and attached to each tier by variantId.
   Prices can drift from what's live on the store between snapshots -
   re-run data/merge_prices.py (after re-fetching the variant batches)
   whenever prices need refreshing, or replace this with a live fetch
   in Phase 3.
   ============================================================ */

(function (global) {
  let priceLookup = null;

  async function loadPrices() {
    if (priceLookup) return priceLookup;
    // A standalone/bundled build (see build-standalone.py) embeds the data
    // directly instead of fetching it, so it works as a single shareable
    // file with no server behind it.
    if (global.__BUNDLED_DATA__) {
      priceLookup = global.__BUNDLED_DATA__.prices;
      return priceLookup;
    }
    const res = await fetch("data/prices.json");
    priceLookup = await res.json();
    return priceLookup;
  }

  function attachPricing(tiers) {
    if (!priceLookup) throw new Error("Pricing not loaded yet - call loadPrices() first");
    return tiers.map((tier) => {
      const priced = priceLookup[tier.variantId];
      if (!priced) {
        console.warn("No price found for variant", tier.variantId);
        return { ...tier, price: 0, pricePerUnit: 0, availableForSale: false };
      }
      return {
        ...tier,
        price: priced.price,
        pricePerUnit: Math.round((priced.price / tier.units) * 100) / 100,
        compareAtPrice: priced.compareAtPrice,
        availableForSale: priced.availableForSale,
        productTitle: priced.productTitle,
      };
    });
  }

  global.Pricing = { loadPrices, attachPricing };
})(typeof window !== "undefined" ? window : globalThis);
